module.exports = __webpack_public_path__ + "static/2005-boats-42f6cfbeb06f325d2647b7c6c7ff0895.jpg";